import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";
import logo from "application/BiblioBoard_Logo_Stacked.png";

import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import RequireRoles from "../auth/RequireRoles";
import UserBrowseView from "./UserBrowseView";
import UserEditView from "./UserEditView";
import { useUsers } from "./userServices";
import { notBlank } from "../util/ext";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  tabs: {
    minHeight: 50,
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
  },

  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  },

  tab: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    minHeight: 40,
    minWidth: 100,
    color: theme.palette.primary.darker,
    borderRadius: 50,
    "&:hover": {
      color: theme.palette.primary.darker,
    },
  },

  selectedTab: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 50,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },

  link: {
    color: "inherit",
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

const ADMIN = ["ROLE_ADMIN"];

const UserAdminView = () => {
  const classes = useStyles();
  const url = useResolvedPath(".").pathname;
  const navigate = useNavigate();
  const state = useLocation().state ?? {};

  const initialSearchState = {
    appliedFilter: [],
    appliedOrganization: state.organizationId,
    orderBy: "accountName",
    orderDirection: "asc",
    roles: [],
    activeOnly: false,
    page: 0,
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useUsers(
    searchState.appliedFilter,
    searchState.roles,
    searchState.appliedOrganization,
    `${searchState.orderBy}:${searchState.orderDirection}`,
    searchState.activeOnly,
    searchState.page,
  );

  return (
    <Container
      id="user-admin-application"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <ApplicationHeader
        applicationLogo={
          <img
            className={classes.creatorLogo}
            alt="User Administration"
            src={logo}
          />
        }
        applicationNavigationWidth="33%"
      />

      <Routes>
        <Route
          path="users"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-users">
                <UserBrowseView
                  searchState={searchState}
                  onSearchStateChange={state => setSearchState(state)}
                  searchResults={searchResults}
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          path="users/:userId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-user">
                <UserEditView
                  onCancel={location =>
                    navigate(notBlank(location) ? location : `${url}/users`)
                  }
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route index element={<Navigate to="users" replace />} />
      </Routes>
    </Container>
  );
};

export default UserAdminView;
